// Module
var code = "<div class=\"concept\">\n  <section class=\"content\"><div ui-view></div></section>\n</div>\n";
// Exports
module.exports = code;